import urljoin from "url-join";
import RequestUtil from "./RequestUtil";


export default class RemoteCall {
    constructor(relativeURL) {
        this.relativeURL = relativeURL;
    }

    _invoke(methodName, param = {}) {
        return RequestUtil._request({
            path: urljoin(this.relativeURL, methodName),
            param,
            method: "POST",
            contentType: "json",
        });
    }

    invoke(methodName, param) {
        return RequestUtil.request({
            path: urljoin(this.relativeURL, methodName),
            param,
            method: "POST",
            contentType: "json",
        });
    }

    _upload(methodName, param) {
        return RequestUtil._request({
            path: urljoin(this.relativeURL, methodName),
            param,
            method: "POST",
            contentType: "formData",
            responseType: "json",
        });
    }

    invokeFile(methodName, param) {
        return RequestUtil.request({
            path: urljoin(this.relativeURL, methodName),
            param,
            method: "POST",
            contentType: "json",
            responseType: "file",
        });
    }

    getFile(methodName, param) {
        return RequestUtil.request({
            path: urljoin(this.relativeURL, methodName),
            param,
            method: "GET",
            contentType: "query",
            responseType: "file",
        });
    }

    get(path, param) {
        return RequestUtil.request({
            path: urljoin(this.relativeURL, path),
            param,
            method: "GET",
            contentType: "query",
        });
    }
}
